import { type ManualViewingFormValues, type ManualViewingPayload } from './manualOperations.types'

const toDubaiViewingDate = (datetimeLocal: string): Date =>
    new Date(`${datetimeLocal}+04:00`)

export const buildManualViewingName = (unit: ManualViewingFormValues['unit']): string => {
    const unitNumber = unit.unitNumber ?? unit.unitReference
    return unitNumber.trim() !== ''
        ? `${unitNumber} <-> ${unit.propertyName} <-> ${unit.areaName}`
        : `${unit.propertyName} <-> ${unit.areaName} <-> Dubai`
}

export const buildManualViewingPayload = (values: ManualViewingFormValues): ManualViewingPayload => ({
    Datetime: toDubaiViewingDate(values.datetimeLocal),
    Statuses: [values.status],
    Name: buildManualViewingName(values.unit),
    Notify: 'Agent',
    Unit: values.unit.unitId,
    User: values.userId,
    ...(values.visitorName?.trim() != null && values.visitorName.trim() !== '' ? { VisitorName: values.visitorName.trim() } : {}),
    ...(values.complaint?.trim() != null && values.complaint.trim() !== '' ? { Complaint: values.complaint.trim() } : {}),
    ...(values.digitalLockPass?.trim() != null && values.digitalLockPass.trim() !== '' ? { DigitalLockPass: values.digitalLockPass.trim() } : {})
})
